import React, { Component } from 'react'
import withStyles from '../../withStylesAdapter';
import withRouter from 'with-router'
import { connect } from 'react-redux'
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Link from '@mui/material/Link';
import API from '../../api/api.js'
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { saveShop, enableLangifyFeature, disableLangifyFeature } from '../../modules/shop';
import { bindActionCreators } from 'redux';
import { withSnackbar } from '../../utils/withSnackbar';
import { useColorMode } from '../../theme/ColorModeProvider';



const uiLanguageSelectorStyles = {
  root: {
    maxWidth: 225,
  },
  selectMenu: {
    //fontSize: 14,
    //paddingBottom: 3,
    display: 'inline-block',
  }
};
const UILanguageSelector = (props) => {
  const { t, i18n } = useTranslation();

  function changeLanguage(e) {
    //i18n.changeLanguage(e.target.value);
    window.localStorage.setItem('ly-ui-language', e.target.value);
    window.location.reload();
  }
  return (
    <FormControl variant="outlined" fullWidth={false} sx={uiLanguageSelectorStyles.root}>
      {/*<InputLabel id="ui-language-select-label">{t('system.uiLanguage')}</InputLabel>*/}
      <Select
        variant="outlined"
        //label="UI language"
        labelId="ui-language-select-label"
        id="ui-language-select-outlined"
        onChange={changeLanguage}
        value={i18n.language}
        sx={{ '& .MuiSelect-select': uiLanguageSelectorStyles.selectMenu }}>
        <MenuItem value='en'>{t('system.english')}</MenuItem>
        <MenuItem value='de'>{t('system.german')}</MenuItem>
        <MenuItem value='it'>{t('system.italian')}</MenuItem>
        <MenuItem value='fr'>{t('system.french')}</MenuItem>
        <MenuItem value='es'>{t('system.spanish')}</MenuItem>
      </Select>
    </FormControl>
  );
}

const UIColorModeSelector = () => {
  const { t } = useTranslation();
  const { mode, setMode } = useColorMode();

  return (
    <RadioGroup
      aria-label="ui color mode"
      name="uiColorMode"
      value={mode}
      onChange={(e) => setMode(e.target.value)}
    >
      <FormControlLabel value="system" control={<Radio />} label={t('tools.colorModeSystem')} />
      <FormControlLabel value="light" control={<Radio />} label={t('tools.colorModeLight')} />
      <FormControlLabel value="dark" control={<Radio />} label={t('tools.colorModeDark')} />
    </RadioGroup>
  );
}

class Settings extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      richtextEditorVersion:            (props.langifyFeatures.find(x => x.name === 'editor_v2') && props.langifyFeatures.find(x => x.name === 'editor_v2').is_enabled) ? 'v2' : 'v1',
      richtextEditorOnParagraphFields:  (props.langifyFeatures.find(x => x.name === 'html_text_2_rich_text') && props.langifyFeatures.find(x => x.name === 'html_text_2_rich_text').is_enabled) ? true : false,
      showStaticMenuEntry:              (typeof props.langifyFeatures.find(x => x.name === 'static_translations') === 'undefined' || props.langifyFeatures.find(x => x.name === 'static_translations').is_enabled) ? true : false,
      customImageUploadPrefixState: (
        props.customImageUploadPrefix === '' ? 'no_prefix' :
        typeof props.customImageUploadPrefix === 'string' ? 'custom_prefix' :
        'default_prefix'
      ),
      customImageUploadPrefixValue: props.customImageUploadPrefix,
      customImageUploadPrefixWarning: null,
      saveCustomImageUploadPrefixSuccess: null,
      saveCustomImageUploadPrefixWarning: false,
      importV1ProductMetafieldsProgress: 0,
      progressingPoFile: false,
      typeTranslationsEnabled: false,
    };
  }

  componentDidMount() {
    API.getMetafield('langify_v2', 'type_translations_enabled', (data) => {
      if(data && data.success && data.result && (data.result.value === 'true' || data.result.value === true)) {
        this.setState({ typeTranslationsEnabled: true });
      }
    });
  }

  onImportV1ProductMetafieldTranslations = () => {
  	const editLanguage = this.props.editLanguage;

    this.setState({
      importV1ProductMetafieldsProgress: 1,
    });

  	API.syncProducts(
  		editLanguage,
  		progress => {
  			console.log('sync products: ' + progress)
  		},
      response => {
        if(response.success == true) {
          this.syncProductMetafields(
            editLanguage,
            response.products.slice(0, 10),
            0,
            progress => {
              console.log('import translations: ' + progress);
              this.setState({
                importV1ProductMetafieldsProgress: progress,
              });
            },
            result => {
              console.log(result);
              this.setState({
                importV1ProductMetafieldsProgress: 100,
              });
            }
          )
        }
      }
    );
  };

  syncProductMetafields = (language, products, index, progress, result) => {
  	if(index >= products.length - 1) {
  		result('!');
  	} else {
	  	API.syncProductMetafields(
	  		products[index].id,
	  		language,
	  		progress => {},
	  		response => {
	  			if(response.success == true && response.metafields.length > 0) {
					API.importV1ProductMetafieldTranslations(
						language,
						products[index].id,
						response.metafields,
						progress => {},
						response => {
				  			progress(Math.ceil(index / (products.length - 1) * 100));
				  			this.syncProductMetafields(language, products, index + 1, progress, result);
						}
					);
	  			} else {
		  			progress(Math.ceil(index / (products.length - 1) * 100));
		  			this.syncProductMetafields(language, products, index + 1, progress, result);
	  			}
	  		}
  		)
  	}
  };

  onUploadPO = (e) => {
    this.setState({progressingPoFile: true});

    const file = e.target.files[0];
    const fileType = file.name.substr(file.name.lastIndexOf('.') + 1);
    
    const formData = new FormData();
    formData.append('file', file);

    API.splitPOfile(
      formData,
      this.props.editLanguage,
      progress => {
        this.setState({progressingPoFile: true});
        console.log('Progress:', progress);
      },
      data => {
        this.setState({progressingPoFile: false});
        console.log('Result:', data);
      }
    );
  }

  toggleRichtextOnParagraphFields = (event) => {
    this.setState({
      richtextEditorOnParagraphFields: !this.state.richtextEditorOnParagraphFields
    }, () => {
      if(this.state.richtextEditorOnParagraphFields) {
        this.props.enableLangifyFeature('html_text_2_rich_text');
      } else {
        this.props.disableLangifyFeature('html_text_2_rich_text');
      }
    });
  }

  toggleshowStaticMenuEntry = (event) => {
    this.setState({
      showStaticMenuEntry: !this.state.showStaticMenuEntry
    }, () => {
      if(this.state.showStaticMenuEntry) {
        this.props.enableLangifyFeature('static_translations');
      } else {
        this.props.disableLangifyFeature('static_translations');
      }
    });
  }

  toggleTypeTranslationsEnabled = (event) => {
    const { t } = this.props;
    this.setState({
      typeTranslationsEnabled: !this.state.typeTranslationsEnabled
    }, () => {
      API.saveCustomMetafield(
        'langify_v2',
        'type_translations_enabled',
        this.state.typeTranslationsEnabled ? 'true' : 'false',
        'boolean',
        (res) => {
          if(res && res.success) {
            this.props.enqueueSnackbar(t('tools.settingSaveSuccess'), {
              variant: 'success'
            });
          } else {
            // revert the switch since the save did not go through
            this.setState({ typeTranslationsEnabled: !this.state.typeTranslationsEnabled });
            this.props.enqueueSnackbar(t('tools.settingSaveError'), {
              variant: 'error'
            });
          }
        }
      );
    });
  }

  changeRichtextEditorVersion = (event) => {
    this.setState({
      richtextEditorVersion: event.target.value
    }, () => {
      if(this.state.richtextEditorVersion === 'v2') {
        this.props.enableLangifyFeature('editor_v2');
      } else {
        this.props.disableLangifyFeature('editor_v2');
      }
    });
  }

  changeCustomImageUploadPrefix = (event) => {
    this.setState({
      customImageUploadPrefixState: event.target.value,
      saveCustomImageUploadPrefixSuccess: null
    });
  }

  saveCustomImageUploadPrefix = async () => {
    let result;
    await this.setState({
    }, async () => {
      if(this.state.customImageUploadPrefixState === 'no_prefix') {
        result = await API.saveShopSetting('custom_image_upload_prefix','');
      } else if(this.state.customImageUploadPrefixState === 'custom_prefix') {
        result = await API.saveShopSetting('custom_image_upload_prefix',this.state.customImageUploadPrefixValue);
      } else {
        result = await API.deleteShopSetting('custom_image_upload_prefix');
      }

      this.props.saveShop({
        settings: {
          custom_image_upload_prefix: result.value
        }
      });

      let message = result.feedback ? result.feedback.message : null;

      if(message) {
        this.props.enqueueSnackbar(<span dangerouslySetInnerHTML={{__html: message}}></span>, {
          variant: 'warning',
          persist: false,
          autoHideDuration: 10000
        })
      };

      this.setState({
        customImageUploadPrefixValue: result.value,
        saveCustomImageUploadPrefixSuccess: result.success,
        saveCustomImageUploadPrefixWarning: result.feedback !== null,
        customImageUploadPrefixWarning: message
      })
    })
  }

  render() {
    const { t, classes } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('tools.titleSettings')}
        </Typography>
        <Divider className="divider-white" />
        <Paper className={classes.root} elevation={1}>
          
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.editorVersionTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>
              {t('tools.editorVersionInfo')}
            </Typography>
            <RadioGroup aria-label="richtext editor" name="richTextEditorVersion" value={this.state.richtextEditorVersion} onChange={this.changeRichtextEditorVersion}>
              <FormControlLabel value="v2" control={<Radio />} label={`${t('tools.editorVersion')} 2.0`} />
              <FormControlLabel value="v1" control={<Radio />} label={`${t('tools.editorVersion')} 1.0`} />
            </RadioGroup>
          </FormControl>

          <div className={classes.spacer} />

          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.editorParagraphTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>
              {t('tools.editorParagraphInfo')}
            </Typography>
            <FormControlLabel
              control={<Switch checked={this.state.richtextEditorOnParagraphFields} onChange={this.toggleRichtextOnParagraphFields} />}
              label={this.state.richtextEditorOnParagraphFields ? 'enabled' : 'disabled'}
            />
          </FormControl>

          <div className={classes.spacer} />

          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.uiLanguageTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>{t('tools.uiLanguageInfo')}</Typography>
            <UILanguageSelector />
          </FormControl>

          <div className={classes.spacer} />

          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.colorModeTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>{t('tools.colorModeInfo')}</Typography>
            <UIColorModeSelector />
          </FormControl>
        </Paper>
        <br />
        <Paper className={classes.root} elevation={1}>
          <FormControl component="fieldset" fullWidth>
              <FormLabel component="legend">{t('tools.customImageUploadPrefixTitle')}</FormLabel>
              <Divider style={{margin: '8px 0'}} />
              <Typography>
              <Trans i18nKey={'tools.customImageUploadPrefixInfo'}>
                </Trans>
              </Typography>
              <RadioGroup aria-label="custom image upload prefix settings" name="customImageUploadPrefix" value={this.state.customImageUploadPrefixState ? this.state.customImageUploadPrefixState : "default_prefix"} onChange={this.changeCustomImageUploadPrefix}>
                <FormControlLabel value="default_prefix" control={<Radio />} label={t('tools.customImageUploadPrefixDefaultPrefix')} />
                <FormControlLabel value="no_prefix" control={<Radio />} label={t('tools.customImageUploadPrefixNoPrefix')} />
                <FormControlLabel value="custom_prefix" control={<Radio />} label={t('tools.customImageUploadPrefixCustomPrefix')} />
                {this.state.customImageUploadPrefixState == 'custom_prefix' &&
                  <div style={{marginLeft: 36}}>
                    <TextField
                      disabled={this.state.customImageUploadPrefixState == 'custom_prefix' ? false : true}
                      // commented out error report attributes
                      // currently there are no useful errors to report
                      //error={this.state.customImageUploadPrefixWarning ? true : false}
                      //label={t('tools.customImageUploadPrefixCustomPrefix')}
                      //helperText={this.state.customImageUploadPrefixWarning ? this.state.customImageUploadPrefixWarning : null }
                      //id={this.state.customImageUploadPrefixWarning ? "outlined-error-helper-text" : "outlined-basic"}
                      id="outlined-basic"
                      value={this.state.customImageUploadPrefixState === 'custom_prefix' && this.state.customImageUploadPrefixValue ? this.state.customImageUploadPrefixValue : null}
                      onChange={(e) => this.setState({ customImageUploadPrefixValue: e.target.value, saveCustomImageUploadPrefixSuccess: null })}

                      variant="outlined"
                      InputProps={{ inputProps: { maxLength: 20, minLength: 1 } }}
                    />
                    <Typography
                      style={{marginTop: 5, color:'grey'}}>
                        {t('tools.customImageUploadPrefixCleanupInfo')}
                    </Typography>
                  </div>
                }
              </RadioGroup>

              <Button
                onClick={this.saveCustomImageUploadPrefix}
                variant="contained"
                color="primary"
                style={{
                  width: '100%',
                  maxWidth: 200,
                  marginLeft: 'auto',
                  backgroundColor: this.state.saveCustomImageUploadPrefixSuccess ? "green" : ""
                }}
              >
              {this.state.saveCustomImageUploadPrefixSuccess ? (
                <div>
                  <CheckCircleIcon style={{fontSize: 18, marginTop: -3, marginRight: 5}}/>
                  {t('system.saveSuccess')}
                </div>
              ) : (
                <div>
                  {t('system.save')}
                </div>
              )}
              </Button>

            </FormControl>
        </Paper>
        <br/>

        <Paper className={classes.root} elevation={1}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.productTypeJsTranslationTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>
              {t('tools.productTypeJsTranslationInfo')}
            </Typography>
            <FormControlLabel
                control={<Switch checked={this.state.typeTranslationsEnabled} onChange={this.toggleTypeTranslationsEnabled} />}
                label={this.state.typeTranslationsEnabled ? 'enabled' : 'disabled'}
            />
          </FormControl>
        </Paper>

        <br />
        <Paper className={classes.root} elevation={1}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel component="legend">{t('tools.staticTranslationsTitle')}</FormLabel>
            <Divider style={{margin: '8px 0'}} />
            <Typography>
              {t('tools.staticTranslationsInfo')}
            </Typography>
            <FormControlLabel
              control={<Switch checked={this.state.showStaticMenuEntry} onChange={this.toggleshowStaticMenuEntry} />}
              label={this.state.showStaticMenuEntry ? 'enabled' : 'disabled'}
            />
          </FormControl>
        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shop, languages }) => ({
  shop: shop,
  langifyFeatures: shop.shop.langify_features,
  customImageUploadPrefix: shop.shop.settings ? shop.shop.settings.custom_image_upload_prefix : '',
  editLanguage: shop.shop.edit_language,
  languages: languages.languages
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveShop,
      enableLangifyFeature,
      disableLangifyFeature
    },
    dispatch
  )

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 20,
    //overflowX: 'auto',
    padding: 24,
  },
  subtext: {
    padding: 2,
    color: '#999'
  },
  heading: {
    color: theme.palette.accentMuted,
    opacity: '0.8'
  },
  h2: {
    color: '#333 !important', 
    fontSize: 28
  },
  content: {
    color: '#999'
  },
  spacer: {
    height: 24
  }
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(withSnackbar(Settings)))))